import { ComponentStoreV2Factory } from "../../../../shared/store/common/component-store-v2.factory";
import { Injectable } from '@angular/core';

@Injectable()
export class PersonInsuranceStore extends ComponentStoreV2Factory {

}
